module.exports = __webpack_public_path__ + "static/media/crs_restaurant_img.85f4ee3c.gif";